import AuthService from '../../../services/authService';
import UserService from '../../user/services/userService';
import ResetPasswordController from './resetPasswordController';

import _ from './resetPassword.scss';

const ResetPassword = {
    template: require('./resetPasswordView.html'),
    controller: ResetPasswordController
};

export default angular.module('app.resetPassword', [])
    .component('resetPassword', ResetPassword)
    .service("AuthService", AuthService)
    .service("UserService", UserService)
    .name;



// WEBPACK FOOTER //
// ./src/app/pages/login/resetPassword/resetPasswordComponent.js